export { default } from './elementAcceptingRef';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/elementAcceptingRef/index.js
// module id = 135
// module chunks = 22